module.exports = __webpack_public_path__ + "static/media/Innstapay-Logo-White.634c6774.png";